import { render } from "./CrmTabBar.vue?vue&type=template&id=40e1ca0d&scoped=true"
import script from "./CrmTabBar.vue?vue&type=script&lang=js"
export * from "./CrmTabBar.vue?vue&type=script&lang=js"

import "./CrmTabBar.vue?vue&type=style&index=0&id=40e1ca0d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e1ca0d"]])

export default __exports__